export const getStyles = () => {
    const styles = {
        container: { 
            height: "calc(90dvh - 75px - 16px - 42px - 80px - 32px - 16px)" 
        }
    };
    return styles;
};